import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import Translator from '../../helpers/Translator';
import {DOMAIN} from '../FilterContainer';
import {bindActionCreators} from 'redux';
import {
    clearFilter,
    flightDurationChange,
    flightDurationChangeUpdate,
    flightDurationsReceived,
    updateMobiscroll
} from '../../actions/FlightsActions';
import {registerAppliedFilter} from '../../actions/FilterGroupsActions';
import BaseFilterComponent from './BaseFilterComponent';
import Timer from '../../helpers/Timer';
import DateTimeFormatter from '../../helpers/DateTimeFormatter';

class FlightDurationBlock extends BaseFilterComponent {
    constructor(props) {
        super(props);
        this.filter = 'duration';
        this.name = 'Flight duration';
        this.urlEnabled = false;
    }

    componentDidMount() {
        const self = this;
        this.timer = new Timer(300, () => {
            self.props.flightDurationChangeUpdate();
        });

        ReactDOM.findDOMNode(this.form).setAttribute('mbsc-form', true);
        this.sliderStart.addEventListener('change', (e) => {
            this.props.flightDurationChange({start: e.target.value});
            if (!this.timer.isRunning()) {
                this.timer.start();
            } else {
                this.timer.restart();
            }
        });

        this.sliderEnd.addEventListener('change', (e) => {
            this.props.flightDurationChange({end: e.target.value});
            if (!this.timer.isRunning()) {
                this.timer.start();
            } else {
                this.timer.restart();
            }
        });

        this.urlEnabled = this.props.duration.filterFromUrl;

        super.componentDidMount();

        this.props.updateMobiscroll();
    }

    initDurationSocketUpdate() {
        if (this.durationSocketUpdateInited === undefined && this.props.socket) {
            this.props.socket.on('duration-filters-update', (data) => {
                this.props.flightDurationsReceived(data);
                this.durationSocketUpdateInited = true;
            });
        }
    }

    renderLabel(value) {
        const hrs = parseInt(value / 3600, 10);
        const mins = parseInt(value / 60, 10) - hrs * 60;

        return DateTimeFormatter.timeFormat(
            hrs,
            mins,
            this.translator.trans('h.'),
            this.translator.trans('m.')
        )
    }

    getSelected(type) {
        return this.props.duration[`${type}Selected`] === -1 ? this.props.duration[type] : this.props.duration[`${type}Selected`];
    }

    hasSingleDuration() {
        return this.props.duration.start === this.props.duration.end;
    }

    render() {
        this.initDurationSocketUpdate();

        this.translator = new Translator(this.props.translator, DOMAIN);

        return (
            <div className={this.hasSingleDuration() ? 'd-none' : ''}>
                <div className={`card-body ${this.isApplied() ? `filter-applied` : null}`}>
                    <div className="font-weight-bold">{this.translator.trans(this.name)}</div>
                    {this.renderClearFilterButton()}
                    <div className="clearfix mb-2">
                        <span className="float-left">
                            <small id="duration-start-label">{this.renderLabel(this.getSelected('start'))}</small>
                        </span>
                        <span className="float-right">
                            <small id="duration-end-label">{this.renderLabel(this.getSelected('end'))}</small>
                        </span>
                    </div>
                    <div ref={(ref) => this.form = ref} id="duration-slider"
                         className="mobiscroll-refresh-element waavo-slider" style={{display: 'none'}}>
                        <input ref={(ref) => this.sliderStart = ref} id="flight-duration-start"
                               className="waavo-double-slider mobiscroll-element" type="range"
                               min={this.props.duration.start} max={this.props.duration.end}
                               value={this.getSelected('start')}
                               onChange={() => {}}
                        />
                        <input ref={(ref) => this.sliderEnd = ref} id="flight-duration-end"
                               className="waavo-double-slider mobiscroll-element" type="range"
                               min={this.props.duration.start} max={this.props.duration.end}
                               value={this.getSelected('end')}
                               onChange={() => {}}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        flightDurationsReceived,
        flightDurationChange,
        flightDurationChangeUpdate,
        registerAppliedFilter,
        clearFilter,
        updateMobiscroll
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        socket: state.SocketReducer.socket,
        duration: state.FlightDurationFilterReducer,
        urlFilters: state.SocketReducer.urlFilters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightDurationBlock);



// WEBPACK FOOTER //
// ./src/components/filters/FlightDurationBlock.js